<template>
  <div class="main_area">
    <div class="promo_category_menu">
      <div :class="actType == '' ? 'swiper-slide actived ' : 'swiper-slide '" @click="changActType('')">
        <div class="icon_circle_card forty_four"><img alt="" src="/static/image/promo_all.png" /><img alt="" src="/static/image/promo_all_a.png" /></div>
        全部优惠
      </div>
      <div style="padding-top: 20px">
        <div class="promo_category_items swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide" @click="changActType(item.id)" v-for="(item, index) in activitytypeList" :key="index">
              <div :class="actType == item.id ? 'promo_category_items_name active' : 'promo_category_items_name'" class="">{{ item.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mainpage promo_page" style="min-height: 510px">
      <div class="promo_container">
        <div class="promo_list layout" id="promo_list">
          <a class="block_content" v-for="(item, index) in activitylistList" v-if="item.state == 1" :key="index" @click="$parent.goNav(`/discountInfo?id=${item.id}`)">
            <div class="card_container">
              <div class="left_block">
                <div class="price_block">
                  <div class="can_get">{{ item.title }}</div>
                </div>
              </div>
              <div class="right_block">
                <div class="img_block"><img class="fallback middle" alt="" :src="item.banner" loading="lazy" /></div>
                <div class="detail_block">
                  <div class="promo_content">
                    <div></div>
                    <div class="title_container">
                      <div class="title">{{ item.title }}</div>
                    </div>
                    <div class="date">{{ item.created_at }}</div>
                  </div>
                  <div class="promo_arrow"><img alt="" src="/static/image/arrow_right.png" /></div>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'discount',
  data() {
    return {
      activitytypeList: [],
      actType: '',
      activitylistList: [],
    };
  },
  created() {
    let that = this;
    that.activitytype();
    that.activitylist();
  },
  methods: {
    activitytype() {
      let that = this;
      that.$apiFun.post('/api/activitytype', {}).then(res => {
        console.log(res);
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          that.activitytypeList = res.data;
        }
      });
    },
    activitylist() {
      let that = this;
      let info = that.actType == '' ? {} : { type: that.actType };
      that.$parent.showLoading();
      that.$apiFun.post('/api/activitylist', info).then(res => {
        console.log(res);
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          that.activitylistList = res.data.data;
        }
        that.$parent.hideLoading();
      });
    },
    changActType(val) {
      let that = this;
      if (val == that.actType) {
        return;
      }
      that.actType = val;
      that.activitylist();
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
.promo_category_menu > div:first-child {
  color: var(--promo_cat_txt_enabled);
}
.icon_circle_card.forty_four img {
  height: 28px;
  /*border-radius: 50%;*/
}
.promo_list > .block_content .type img {
  margin-right: 5px;
  /*width: 100%;*/
  height: 28px;
  /*border-radius: 50%;*/
}
.promo_category_items .swiper-slide {
  text-align: center;
  width: 25%;
  color: var(--promo_cat_txt_enabled);
}
.promo_category_items_name {
  text-align: center;
  border-radius: var(--tab_game_radius);
  padding: 5px;
  color: var(--tab_game_txt_inactive);
  border: var(--tab_game_borderthick_inactive) solid var(--tab_game_border_inactive);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background: var(--tab_game_bg_inactive);
  box-shadow: unset;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 90%;
}
.promo_category_items_name.active {
  color: var(--tab_game_txt_active);
  margin: 0px auto;
  background: var(--tab_game_bg_active);
  -webkit-box-shadow: 0px 4px 15px rgb(0 0 0 / 12%);
  box-shadow: 0px 4px 15px rgb(0 0 0 / 12%);
  border: var(--tab_game_border_active);
}
</style>



// WEBPACK FOOTER //
// src/components/mode/discount.vue